import { ReactNode, useState } from "react";
import infoIcon from "~/assets/icon-info.svg";
import * as Tooltip from "@radix-ui/react-tooltip";
import { Testable } from "~/lib/testing";
import Image from "~/components/atoms/Image";

interface Props extends Testable {
    children: ReactNode;
}

export default function InformationTooltip({ children, "data-testid": testId }: Props) {
    const [showInfo, setShowInfo] = useState<boolean>(false);
    return (
        <Tooltip.Provider delayDuration={200}>
            <Tooltip.Root open={showInfo} onOpenChange={setShowInfo}>
                <Tooltip.Trigger onClick={() => setShowInfo(s => !s)}>
                    <Image
                        alt="tooltip"
                        className="relative w-[16px] cursor-pointer"
                        data-testid={testId}
                        src={infoIcon}
                    />
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content className="z-50" sideOffset={5}>
                        {children}
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        </Tooltip.Provider>
    );
}
